var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplianceBreadcrumb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 1.5C15.5967 1.5 16.169 1.73705 16.591 2.15901C17.0129 2.58097 17.25 3.15326 17.25 3.75V5.25H15.75V14.25C15.75 14.8467 15.5129 15.419 15.091 15.841C14.669 16.2629 14.0967 16.5 13.5 16.5H3C2.40326 16.5 1.83097 16.2629 1.40901 15.841C0.987053 15.419 0.75 14.8467 0.75 14.25V12.75H12.75V14.25C12.75 14.4337 12.8175 14.611 12.9395 14.7483C13.0616 14.8856 13.2298 14.9733 13.4122 14.9948L13.5 15C13.6837 15 13.861 14.9325 13.9983 14.8105C14.1356 14.6884 14.2233 14.5202 14.2448 14.3378L14.25 14.25V3H4.5C4.3163 3.00002 4.139 3.06747 4.00172 3.18954C3.86444 3.31161 3.77674 3.47981 3.75525 3.66225L3.75 3.75V11.25H2.25V3.75C2.25 3.15326 2.48705 2.58097 2.90901 2.15901C3.33097 1.73705 3.90326 1.5 4.5 1.5H15Z",
    fill: "#4A4A68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplianceBreadcrumb);
export default __webpack_public_path__ + "static/media/compliance-breadcrumb.23dee5d52dce349b487c43b4e0fa0a6b.svg";
export { ForwardRef as ReactComponent };